import { render } from "./feedback.vue?vue&type=template&id=fb8c4ab0&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"

import "./feedback.vue?vue&type=style&index=0&id=fb8c4ab0&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8c4ab0"]])

export default __exports__